import { selectAllStrings } from '../features/language/languageSlice';
import { useSelector } from 'react-redux';
import { copyTextToClipboard } from '../lib/clipboard-helper';

const ShareDialog = ({link, onClose}) => {
    const strings = useSelector(selectAllStrings);

    const copyLink = (event) => {
        event.preventDefault();
        copyTextToClipboard(strings.it_very_usefull+'\n'+link);
        onClose();
    };

    return <div className="modal">
        <div className="share-dialog is-open">
            <header>
                <h3 className="dialog-title">{strings.share_poi}</h3>
                <button className="close-button" onClick={onClose}><svg><use href="#close"></use></svg></button>
            </header>
            <div className="link">
                <div className="pen-url">{link}</div>
                <button className="copy-link" onClick={copyLink}>{strings.copy_link}</button>
            </div>
        </div>
        <svg className="hidden">
        <defs>
        <symbol id="close" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather featherWSquare"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line></symbol>
        </defs>
        </svg>
    </div>

};

export default ShareDialog;